import api from "./api";
import { gvmEditPath } from "./apiPaths";

export type VendorSubCategory = {
  code: string;
  label: string;
};

export type VendorCategory = {
  code: string;
  label: string;
  sub_categories: VendorSubCategory[];
};

type VendorCategoriesResponse = {
  vendor_categories?: VendorCategory[];
};

/**
 * The Vendor Profile Type master — Major categories with their Sub-categories.
 *
 * Read only by internal screens (the Vendor Profile page and its edit drawer),
 * which always hold a Bouncer token: an onboarded vendor is provisioned a
 * Bouncer account at activation. So it rides the same `/vip/gvm/api/v1` prefix
 * as every other profile call and needs no gateway alias of its own. The
 * onboarding wizard and the VM enrichment form take their Super/Sub-category
 * options from the Tasker form schema and never call this.
 */
export async function fetchVendorCategories(): Promise<VendorCategory[]> {
  const res = (await api.get(
    gvmEditPath("/onboarding/vendor-categories"),
  )) as VendorCategoriesResponse | null;
  return res?.vendor_categories ?? [];
}
